module.exports = __webpack_public_path__ + "img/6.5da99696.svg";